<template>
  <div class="tracking-info">
    <div class="py-2 px-3 scrollable">
      <tracking-step
        v-for="(step, index) in steps.slice().reverse()"
        :key="step.requestId"
        :step="step"
        :last="index === last"
        :single-item="steps.length === 1"
      />
    </div>
    <div
      v-if="error"
      class="text-center my-3"
    >
      <small>{{ $t('global.noReport') }}</small>
    </div>
    <div
      v-if="busy"
      class="spinner-wrapper"
    >
      <vt-loading />
    </div>
  </div>
</template>

<script>
import TrackingStep from './TrackingStep'
import commonRequestService from '@/api/resources/common/commonRequestService'

export default {
    name: 'TrackingInfo',
    components: {
        TrackingStep
    },
    props: {
        laboratoryId: { type: Number, required: true },
        requestId: { type: Number, required: true },
        trackingResource: { type: Object, default: () => { return commonRequestService } }
    },
    data() {
        return {
            steps: []
        }
    },
    computed: {
        last() {
            return this.steps.length - 1
        }
    },
    created() {
        this.loadTracking()
    },
    methods: {
        async loadTracking() {
            this.busy = true
            this.error = false
            try {
                this.steps = await this.trackingResource.getTracking(this.laboratoryId, this.requestId)
                if (!this.steps.length) this.error = true
            } catch (error) {
                this.error = true
            } finally {
                this.busy = false
            }
        }
    }
}

</script>
